export default __webpack_public_path__ + "static/media/YT3.6424ac58.png";